<template>
  <base-card class="career-cell__base-card">
    <!-- <div class="d-flex align-items-center justify-content-between"> -->
    <div
      v-if="ranking"
      class="career-cell__ranking d-none d-sm-flex"
      :class="{overlay_class4: addRankingOverlay}"
    >
      <fa-icon
        icon="grip-vertical"
        class="career-cell__ranking__grip"
      />
      <span class="career-cell__ranking__number">{{ ranking }}</span>
    </div>
    <div class="career-cell">
      <div class="career-cell__data ml-0 d-block d-lg-none mt-1">
        <div class="career-cell__value row w-100">
          <div class="col-10">
            <div
              v-if="ranking"
              class="d-flex row d-sm-none m-1"
            >
              <base-button
                class="col-1 m-0"
              >
                {{ ranking }}
              </base-button>

              <base-button
                inverse
                block
                class="col-5"
                :disabled="1===ranking"
                @click="$emit('change-ranking', 'subir', ranking - 1)"
              >
                <fa-icon icon="chevron-up" /> Subir
              </base-button>
              <base-button
                inverse
                block
                class="col-5"
                :disabled="finalIndex===ranking"
                @click="$emit('change-ranking', 'bajar', ranking - 1)"
              >
                Bajar <fa-icon icon="chevron-down" />
              </base-button>
            </div>
          </div>
          <div class="col-1 base-nav-item__icon trash-button">
            <fa-icon
              icon="trash"
              @click="deleteFavorite"
            />
          </div>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="career-cell__title">
          <div class="row">
            <div class="col">
              <PillKind :kind="career.career_kind" />
            </div>
          </div>
          <div class="row">
            <div class="col">
              {{ career.career_name }}
            </div>
          </div>
        </div>
        <div class="career-cell__category">
          {{ career.career_area | lowercase | capitalize }}
        </div>
        <div class="d-flex d-md-none mt-3">
          <SelectUniversities
            :key="career.career_name"
            :career="career"
            :class="{overlay_class: addUniversityOverlay && ranking === 1}"
            @select="patchCareer"
          />
        </div>
        <div class="d-none d-md-block ml-auto mr-0">
          <SelectUniversities
            :key="career.career_name"
            :career="career"
            :class="{overlay_class: addUniversityOverlay && ranking === 1}"
            @select="patchCareer"
          />
        </div>
      </div>
      <div class="career-cell__data col-lg-1 pl-0">
        <div
          class="career-cell__value d-block d-lg-none row w-100 my-1"
          style="text-align: center;"
        >
          <div>
            Salario Promedio:
          </div>
          <div>
            <span v-if="Math.trunc(career.income)">${{ Math.trunc(career.income) }}</span>
            <span v-else>Sin datos</span>
          </div>
        </div>
        <div
          class="career-cell__value d-none d-lg-block"
          style="text-align: center;"
        >
          <span v-if="Math.trunc(career.income)">${{ Math.trunc(career.income) | currency }}</span>
          <span v-else>Sin datos</span>
        </div>
      </div>
      <div class="col-xs-12 col-lg-7 col-md-6">
        <div class="row">
          <div class="career-cell__data col-lg-3 ml-0">
            <div :class="ifThinMobileBorder">
              <div :class="(ranking?'col-12':'col-8')+' d-lg-none col-sm-6'">
                Lengua Española
              </div>
              <div
                :class="(ranking?'col-12 mb-1':'col-4')+
                  ' career-cell__value col-lg-12 col-sm-6'"
              >
                <BaseProgress
                  grade
                  size="xl"
                  :value="Math.round(career.grades['Lengua Española']*100)/100"
                  :max="30"
                />
              </div>
            </div>
          </div>
          <div class="career-cell__data col-lg-3 ml-0">
            <div :class="ifThinMobileBorder">
              <div :class="(ranking?'col-12':'col-8')+' d-lg-none col-sm-6'">
                Matemáticas
              </div>
              <div
                :class="(ranking?'col-12 mb-1':'col-4')+
                  ' career-cell__value col-lg-12 col-sm-6'"
              >
                <BaseProgress
                  grade
                  size="xl"
                  :value="Math.round(career.grades['Matemáticas']*100)/100"
                  :max="30"
                />
              </div>
            </div>
          </div>
          <div class="career-cell__data col-lg-3 ml-0">
            <div :class="ifThinMobileBorder">
              <div :class="(ranking?'col-12':'col-8')+' d-lg-none col-sm-6'">
                Ciencias Sociales
              </div>
              <div
                :class="(ranking?'col-12 mb-1':'col-4')+
                  ' career-cell__value col-lg-12 col-sm-6'"
              >
                <BaseProgress
                  grade
                  size="xl"
                  :value="Math.round(career.grades['Ciencias Sociales']*100)/100"
                  :max="30"
                />
              </div>
            </div>
          </div>
          <div class="career-cell__data col-lg-3 ml-0">
            <div :class="ifThinMobileBorder">
              <div :class="(ranking?'col-12':'col-8')+' d-lg-none col-sm-6'">
                Ciencias Naturales
              </div>
              <div
                :class="(ranking?'col-12 mb-1':'col-4')+
                  ' career-cell__value col-lg-12 col-sm-6'"
              >
                <BaseProgress
                  grade
                  size="xl"
                  :value="Math.round(career.grades['Ciencias Naturales']*100)/100"
                  :max="30"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="career-cell__data col-lg-1 ml-0 d-none d-lg-block">
        <div class="career-cell__value">
          <div class="base-nav-item__icon trash-button">
            <fa-icon
              icon="trash"
              @click="deleteFavorite"
            />
          </div>
        </div>
      </div>
      <!-- <div class="py-2 mb-2">
          <CareerInfo />
        </div>
        <div>
          <SelectUniversities />
        </div> -->
    </div>
  </base-card>
</template>
<script>
// import CareerInfo from './CareerInfo.vue';
import SelectUniversities from './SelectUniversities.vue';
import { studentsService } from '../../_services';
import CONFIG from '../../config';

export default {
    name: 'CareerCell',
    components: {
        // CareerInfo,
        SelectUniversities,
    },
    props: {
        career: {
            type: Object,
            required: true,
        },
        ranking: {
            type: Number,
            required: false,
            default: null,
        },
        finalIndex: {
            type: Number,
            default: 0,
        },
        addUniversityOverlay: {
            type: Boolean,
            required: true,
        },
        addRankingOverlay: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        ifMobile() {
            return window.innerWidth < CONFIG.responsive.minWidth;
        },
        ifThinMobileBorder() {
            if (this.ifMobile) {
                return 'row w-100 m-1 border-bottom';
            }
            return 'row w-100';
        },
    },
    methods: {
        deleteFavorite() {
            this.$emit('delete-favorite', this.career.career_uuid);
        },
        patchCareer(added, impartedId) {
            const temp = [...this.career.imparted_careers];
            if (added) {
                temp.push(impartedId);
            } else {
                temp.splice(temp.indexOf(impartedId), 1);
            }
            this.career.imparted_careers = [...temp];
            studentsService.patchCareerPreference(
                this.$store.getters['authentication/student_uuid'],
                this.career.uuid,
                { imparted_careers: temp },
            );
        },
    },
};
</script>
<style lang="scss">
.overlay_class4 {
  position: relative;
  z-index: 99999;
  background-color: #dddddd;

  &--active {
    opacity: 1;
  }
}
.career-cell{
  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    padding: 1.25rem;
    // justify-content: space-between;
  }
  &__base-card .card-body{
    display: flex;
    align-items: stretch;
    padding: 0;
  }

  &__ranking{
    border-right: solid 1px #ddd;
    display: flex;
    align-items: center;

    padding: 1.25rem;

    &__number{
      font-size: 2.25rem;
      color: #4A4A4A;
    }

    &__grip{
      color: #D8D8D8;
      margin-right: 1rem;
      cursor: grab;
    }

  }

  &__title{
    font-size: 1.2rem;
    line-height: 1;
    margin-top: 0.5rem;
    // margin-bottom: 1rem;
    min-width: 200px;

    :last-child  div {
      margin: 4.8px 0;
    }
  }
  &__category{
    font-size: 0.8rem;
    opacity: 0.5;
    margin-bottom: 0.25rem;
  }
  &__data{
    display: flex;
    text-align: center!important;
    @media (min-width: 768px) {
      flex-direction: column-reverse;
      // margin: 0 1rem;
    }
  }
  &__label{
    min-width: 120px;
    font-size: 0.8rem;
    @media (min-width: 768px) {
      width: 100%;
      // display: none;
    }
  }
  &__value{
    font-size: 0.8rem;
    font-weight: bold;
    @media (min-width: 768px) {
      font-size: 1.2rem;
      font-weight: 100;
      white-space: nowrap;
    }
  }
  &__bar{
    @media (min-width: 768px) {
      margin: 6px 0;
    }
  }
  .trash-button {
    cursor: pointer;
    font-size: 1.2rem;
    color: #4A90E2
  }
}
</style>
